"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bar = void 0;

var _react = _interopRequireDefault(require("react"));

var _stylitas = require("@creditas/stylitas");

var _utils = require("@creditas/utils");

var _propTypes = require("prop-types");

var _core = require("@emotion/core");

const propTypes = {
  percentage: _propTypes.number
};
const defaultProps = {
  percentage: 0
};
const enhancer = (0, _utils.compose)(_utils.withForwardRef, (0, _utils.withDefaultProps)(propTypes, defaultProps));
const Wrapper = _stylitas.styled.div`
  bottom: 0;
  position: absolute;
  height: 8px;
  width: 100%;
  background: ${({
  theme
}) => theme.bColorneutral03};
  border-radius: 4px;

  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    height: 8px;
    width: ${({
  percentage
}) => percentage * 100 / 100}%;
    background: ${({
  theme
}) => theme.bColorsecondary04};
    border-radius: 4px;
  }
`;
const Bar = enhancer(({
  percentage
}) => {
  return (0, _core.jsx)(Wrapper, {
    percentage: percentage
  });
});
exports.Bar = Bar;